/* EndNode — Custom React Flow node marking end of workflow */
import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import css from '../../AutomationEditor.module.css';
import NodeIcon from './NodeIcon';

export default memo(function EndNode({ data, selected }: NodeProps) {
  const color = (data.color as string) || '#6b7280';

  return (
    <div
      className={`${css.customNode}${selected ? ` ${css.selected}` : ''}`}
      style={{ borderColor: color }}
    >
      <div className={css.nodeHeader}>
        <div className={css.nodeIcon} style={{ background: color }}>
          <NodeIcon icon={(data.icon as string) || '⏹'} />
        </div>
        <div>
          <div className={css.nodeLabel}>{data.label as string}</div>
          <div className={css.nodeType}>End</div>
        </div>
      </div>
      <Handle type="target" position={Position.Top} id="default" />
    </div>
  );
});
